import {useCallback} from 'react'
import {flowRight} from 'lodash-es'

// Components
import CategoryComponent from './category.component'

// HOCs
import {withHooks, withLayout} from '~/hocs'

// Constants
import {CATEGORY} from '~/constants/pages.constant'

const useHooks = (props) => {
  const {
    navigate,
    pageContext: {
      products,
      limit,
      page,
      pageCount,
      totalCount: count,
      categoryName,
      pathWithoutPage,
    },
  } = props

  const hidePrevButton = page > Math.ceil(pageCount)
  const hideNextButton = page >= Math.ceil(pageCount)

  const handlePageChange = useCallback(
    ({selected}) => {
      const pageIndex = selected + 1

      navigate(pageIndex === 1 ? pathWithoutPage : `${pathWithoutPage}/trang-${pageIndex}`)
    },
    [navigate, pathWithoutPage],
  )

  const hrefBuilder = useCallback(
    (pageIndex) => (pageIndex === 1 ? pathWithoutPage : `${pathWithoutPage}/trang-${pageIndex}`),
    [pathWithoutPage],
  )

  return {
    productsPerPage: limit,
    page,
    products,
    count,
    pageCount,
    hidePrevButton,
    hideNextButton,
    categoryName,
    handlePageChange,
    hrefBuilder,
  }
}

const CategoryTemplate = flowRight(
  withHooks(useHooks),
  withLayout({pageName: CATEGORY}),
)(CategoryComponent)

export default CategoryTemplate
